// tslint:disable:max-line-length

import React from 'react';

export const ActionClose = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <polygon points="15.9,2.2 13.8,0.1 8,5.9 2.2,0.1 0.1,2.2 5.9,8 0.1,13.8 2.2,15.9 8,10.1 13.8,15.9 15.9,13.8 10.1,8" />
    </svg>
  );
};
